import { AppState } from '../../types';

export const getAllSessions = (state: AppState) => state.userOverlay.allSessions;
export const getMatchingSessionsOrClips = (state: AppState) =>
  state.userOverlay.matchingSessionsOrClips;
export const getSegmentDefinition = (state: AppState) => state.userOverlay.segmentDefinition;
export const getEventSearch = (state: AppState) => state.userOverlay.eventSearch;
